
<div class="container" style="padding-top: 10%;min-height:60vh">
    <h1 style="color:#e6e64c;text-align: center; font-size: 5em;font-weight: bold">Privacy</h1>
</div>
    